"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.forTrue = void 0;
function wait(timeoutMs, value = null) {
    return new Promise((resolve) => {
        setTimeout(() => resolve(value), timeoutMs);
    });
}
exports.default = wait;
function forTrue(fn) {
    return __awaiter(this, void 0, void 0, function* () {
        const count = 0;
        return new Promise((resolve, reject) => {
            if (fn()) {
                resolve(true);
                return;
            }
            const interval = setInterval(() => __awaiter(this, void 0, void 0, function* () {
                if (fn()) {
                    clearInterval(interval);
                    resolve(true);
                    return;
                }
                if (count >= 100)
                    reject();
            }), 50);
        });
    });
}
exports.forTrue = forTrue;
//# sourceMappingURL=wait.js.map